import { render, staticRenderFns } from "./CircleCom.vue?vue&type=template&id=37d180d3&scoped=true"
import script from "./CircleCom.vue?vue&type=script&lang=js"
export * from "./CircleCom.vue?vue&type=script&lang=js"
import style0 from "./CircleCom.vue?vue&type=style&index=0&id=37d180d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d180d3",
  null
  
)

export default component.exports